// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCPaSy5G69Q8sY-mSY9L5fFejeaiL8zqwU",
  authDomain: "mati-edge-elite.firebaseapp.com",
  databaseURL: "https://mati-edge-elite-default-rtdb.firebaseio.com",
  projectId: "mati-edge-elite",
  storageBucket: "mati-edge-elite.firebasestorage.app",
  messagingSenderId: "433277849859",
  appId: "1:433277849859:web:bcaae7911ab9ad5b9dd936"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);            // RTDB (legacy: picks, signals_history)
export const firestore = getFirestore(app);    // Firestore (users/{uid})
// Firebase Auth usa `browserLocalPersistence` por default. Eso significa que
// la sesión persiste entre refreshes Y se sincroniza entre tabs vía storage
// events internos: si el usuario hace signOut() en una tab, todas las demás
// reciben `onAuthStateChanged(user=null)` automáticamente y AuthContext
// las redirige al login (UX audit ISSUE 14: validado que funciona sin
// código extra; no se requiere listener manual de storage events).
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// FASE 3.B: Cloud Functions en southamerica-east1 (callables: flowCreatePayment,
// requestTelegramBindingCode). flowConfirm es HTTP, no se llama desde el cliente.
export const functions = getFunctions(app, 'southamerica-east1');

// FASE 1.B: default export para auth/AuthContext.jsx y auth/authHelpers.js
// (que usan `import app from '../firebase'`).
export default app;
